export default {
  ADD_EXHIBITOR: 'Add exhibitor',
  NO_EXHIBITOR: 'You do not have any exhibitors added yet!',
  EXHIBITOR_NAME: 'Exhibitor name',
  EXHIBITOR_EMAIL: 'Exhibitor email',
  EXHIBITOR_CONTACT: 'Exhibitor contact',
  CITY: 'City',
  COUNTRY: 'Country',
  ADDRESS: 'Address',
  ORGANISATION: 'Organisation',
  TRANSACTION_ID: 'Transaction Id',
  DATE_OF_PURCHASE: 'Date of purchase',
  DEVICES_COUNT: 'Devices count',
  ADD_EXHIBITOR_SUCCESS: 'Your exhibitor profile is set up successfully!',
  LICENSE_DETAILS: 'License details',
  UPDATE_EXHIBITOR_SUCCESS: 'Your exhibitor profile is updated successfully!',
  EDIT_EXHIBITOR: 'Edit exhibitor'
}
